import { render, staticRenderFns } from "./RedirectExternalLinks.vue?vue&type=template&id=0b75339d&scoped=true"
import script from "./RedirectExternalLinks.vue?vue&type=script&lang=js"
export * from "./RedirectExternalLinks.vue?vue&type=script&lang=js"
import style0 from "./RedirectExternalLinks.vue?vue&type=style&index=0&id=0b75339d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b75339d",
  null
  
)

export default component.exports